'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import {
  BadgeCheck,
  CalendarDays,
  ChevronRight,
  Clock,
  Handshake,
  MapPin,
  UsersRound,
} from 'lucide-react';
import styles from './BusinessGameHero.module.scss';
import { businessGameBasics } from './business-game.content';

const facts = [
  {
    icon: CalendarDays,
    value: '23 июня',
    label: 'дата проведения',
  },
  {
    icon: Clock,
    value: businessGameBasics.time,
    label: 'время проведения',
  },
  {
    icon: UsersRound,
    value: 'Бесплатно',
    label: 'по предварительной регистрации',
  },
];

export default function BusinessGameHero() {
  const router = useRouter();

  const handleScroll = (event: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    event.preventDefault();

    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      window.history.pushState(null, '', `#${targetId}`);
    } else {
      router.push(`#${targetId}`);
    }
  };

  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.breadcrumbs}>
            <Link href="/events" className={styles.breadcrumbLink}>
              Все мероприятия
            </Link>
            <span className={styles.breadcrumbSeparator}>/</span>
            <span className={styles.breadcrumbCurrent}>Деловая игра</span>
          </div>

          <h1 className={styles.title}>
            <span>
              Заказчик и <br className={styles.mobileBreak} />Поставщик:
            </span>
            <span className={styles.highlight}>
              точки <br className={styles.mobileBreak} />соприкосновения
            </span>
          </h1>

          <p className={styles.lead}>
            Деловая игра для заказчиков и поставщиков, где участники разбирают конфликтные
            точки закупочного процесса, техническое задание, НМЦК, приемку ТРУ и аргументы
            сторон на практической кейсовой ситуации.
          </p>

          <div className={styles.partnerPanel}>
            <div className={styles.partnerIcon}>
              <Handshake size={28} />
            </div>
            <p>
              Совместное мероприятие команды АБВЗАКУПКИ и Евгения Вдовина, эксперта-практика
              в области госзакупок с 25-летним стажем, специализирующегося на ценообразовании,
              стандартизации закупок и B2G-продажах.
            </p>
          </div>

          <div className={styles.stats}>
            {facts.map((fact) => {
              const Icon = fact.icon;

              return (
                <div key={fact.label} className={styles.stat}>
                  <div className={styles.statIcon}>
                    <Icon size={28} />
                  </div>
                  <div className={styles.statContent}>
                    <div className={styles.statNumber}>{fact.value}</div>
                    <div className={styles.statLabel}>{fact.label}</div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className={styles.ctaSection}>
            <a
              href="#form"
              className={styles.primaryButton}
              onClick={(event) => handleScroll(event, 'form')}
              aria-label="Зарегистрироваться на деловую игру"
            >
              <span>Зарегистрироваться</span>
              <ChevronRight size={30} />
            </a>

            <div className={styles.notes}>
              <p className={styles.ctaNote}>
                <MapPin size={20} />
                <span>
                  <strong>Место проведения:</strong> {businessGameBasics.place}, {businessGameBasics.placeDetails}
                </span>
              </p>
              <p className={styles.ctaNote}>
                <BadgeCheck size={20} />
                <span>Зарегистрируйся сам и зарегистрируй своего коллегу. Ждем ваших поставщиков и заказчиков</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
